<template>
  <div class="page-component-wrapper">
    <el-tabs v-show="!isEditorOpen" v-model="activeTab" class="tabs_full-height">
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :name="tab.name"
        class="customer-tab"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{tab.label}}</span>
        </template>
        <grid
          :config="gridConfigs[tab.configName]"
        ></grid>
      </el-tab-pane>
    </el-tabs>
    <editor
      :config="{id: gridConfigs.mainGridID, api: 'RFQs/Get/'}"
      :moduleName="moduleName"
      :eventID="eventID"
      @on-open="isEditorOpen = true"
      @on-close="isEditorOpen = false"/>
  </div>
</template>

<script>
import gridConfigRFQ from './GridConfigRFQ'
import gridConfigRFQ3 from './GridConfigRFQ3'
import StoreModule from './StoreModule.js'
export default {
  name: 'CustomerPoOpenIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'CustomerPoClose' */ './Editor')
  },
  created () {
    const store = this.$store
    const moduleName = this.moduleName
    if (store && !store.state[moduleName]) {
      store.registerModule(moduleName, StoreModule)
    }
  },
  beforeDestroy () {
    this.$store.dispatch(`${this.moduleName}/resetState`)
  },
  data () {
    return {
      isEditorOpen: false,
      moduleName: 'customer-po-close',
      eventID: 'customer-po-close',
      activeTab: 'rfq',
      gridConfigs: {
        mainGridID: 'customer-po-close',
        gridConfigRFQ: gridConfigRFQ,
        gridConfigRFQ3: gridConfigRFQ3
      },
      tabs: [
        { label: this.L10n('rfq'), name: 'rfq', configName: 'gridConfigRFQ' },
        { label: this.L10n('parts'), name: 'parts', configName: 'gridConfigRFQ3' }
      ]
    }
  }
}
</script>
<style lang="stylus">
.customer-tab {
  > .el-tabs__header{
    margin 0
  }
}
</style>
